const isResponseSuccess = (response) => /^2\d\d$/.test(response?.status);
const isResponseError = (response) => !isResponseSuccess(response);

export {isResponseError};
